import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'styled-components';
import { Menu, Dropdown, Drawer, Divider } from 'antd';
import { Text } from '../../Reusable/Text';
import { Flex, FlexColumn } from '../../Reusable/Refresh/Container';


// Actions
import { TextButton } from '../../Reusable/Refresh/Button';
import AccountingSysConnect from '../../Reusable/AccountingSysConnect';
import BankConnect from '../../Settings/External Bank Connect/Index';

import ConnectionIcon from '../../../Images/connections-active.svg';
import BankIcon from '../../../Images/bank-icon/Banking.png';
import ModalClose from '../../../Images/modal-close.png'


class Connections extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showChatModal: false,
        }
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {
        return (
            <Flex centerHorizontally style={{ width: "100%" }}>
                <TextButton underline icon={<img width='24px' height='24px' src={ConnectionIcon} color="white" />} style={{ textAlign: "left" }} text={"Connections"}
                    onClick={() => this.setState({ showDrawer: true })}
                ></TextButton>
                <Drawer placement="right" width={"100%"}
                    closeIcon={
                        <img width='24px' height='24px' src={ModalClose} style={{ marginRight: "18px" }} onClick={() => this.setState({ showDrawer: false })} />
                    }
                    visible={this.state.showDrawer}>
                    <FlexColumn start gap="24px" fullHeight style={{ marginBottom: 24 }}>
                        <FlexColumn>
                            <Text heading style={{ margin: "-10px 0 24px 0" }}>Connection Details</Text>
                        </FlexColumn>
                        <FlexColumn start style={{ marginTop: "0", marginBottom: "12px" }}>
                            <Text margin="0px 0px 12px 0px" weight='500' spacing="0.08em" caption>ACCOUNTING SYSTEMS</Text>
                            <AccountingSysConnect
                                showUpload={false}
                                location={this.props.location}
                                onAccountingSysConnected={(options) => {
                                    console.log("onAccountingSysConnected", options)
                                    this.setState({ accountingSysConnected: options.accountingSysConnected })
                                }}
                                showUploadOption
                            />
                        </FlexColumn>
                        <Divider style={{ margin: "24px 0" }} />
                        <FlexColumn style={{ margin: "12px 0 0" }} fullWidth>
                            <Flex between>
                                <FlexColumn style={{ width: this.state.accountingSysConnected ? 500 : 800, flexDirection: "column" }} >
                                    <Text margin="0px 0px 12px 0px" weight='500' spacing="0.08em" caption>BUSINESS BANK STATEMENTS</Text>
                                    <Text margin="0px 0px 12px 0px" >Connect your primary bank account and any other accounts associated with your business. This will enable us to better assess your application.</Text>
                                </FlexColumn>
                                <FlexColumn style={{ width: `25%`, flexDirection: "column" }}>
                                </FlexColumn>
                            </Flex>
                            <FlexColumn start gap="24px" left>
                                {
                                    <BankConnect store={this.props.store} key="bankConnect" />
                                }
                            </FlexColumn>
                        </FlexColumn>
                    </FlexColumn>
                </Drawer>
                {/* <Dropdown
                    placement='bottomRight'
                    align={{ overflow: { adjustX: true, adjustY: true } }}
                    overlay={<Menu style={{ padding: 24, borderRadius: 8 }}>
                        <FlexColumn start style={{ marginTop: "0", marginBottom: "12px" }}>
                            <Text margin="0px 0px 12px 0px" weight='500' spacing="0.08em" caption>ACCOUNTING SYSTEMS</Text>
                            <AccountingSysConnect
                                showUpload={false}
                                location={this.props.location}
                                onAccountingSysConnected={(options) => {
                                    console.log("onAccountingSysConnected", options)
                                    this.setState({ accountingSysConnected: options.accountingSysConnected })
                                }}
                                showUploadOption
                            />
                        </FlexColumn>
                    </Menu>}
                >
                    <Flex style={{ zIndex: 99, cursor: 'pointer', marginLeft: '5px' }}>
                        <TextButton icon={<img width='24px' height='24px' src={ConnectionIcon} color="white" />} style={{ textAlign: "left", paddingRight: 10 }} text={"Accounts"}></TextButton>
                    </Flex>
                </Dropdown>
                <Dropdown
                    placement='bottomRight'
                    align={{ overflow: { adjustX: true, adjustY: true } }}
                    overlay={<Menu style={{ padding: 24, borderRadius: 8 }}>
                        <FlexColumn style={{ margin: "12px 0 0" }} fullWidth>
                            <Flex between>
                                <FlexColumn style={{ width: `75%`, flexDirection: "column" }} >
                                    <Text margin="0px 0px 12px 0px" weight='500' spacing="0.08em" caption>BUSINESS BANK STATEMENTS</Text>
                                    <Text width="800px" margin="0px 0px 12px 0px" >Connect your primary bank account and any other accounts associated with your business. This will enable us to better assess your application.</Text>
                                </FlexColumn>
                                <FlexColumn style={{ width: `25%`, flexDirection: "column" }}>
                                </FlexColumn>
                            </Flex>
                            <FlexColumn start gap="24px" left>
                                {
                                    <BankConnect store={this.props.store} key="bankConnect" />
                                }
                            </FlexColumn>
                        </FlexColumn>
                    </Menu>}
                >
                    <Flex style={{ zIndex: 99, cursor: 'pointer', marginLeft: '5px' }}>
                        <TextButton icon={<img width='24px' height='24px' src={BankIcon} color="white" />} style={{ textAlign: "left" }} onClick={() => { }} text={"Banks"}></TextButton>
                    </Flex>
                </Dropdown> */}
            </Flex>
        );
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer,
        creditStore: state.creditAppReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Connections)));